/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import './models';
import '../../../common/currency';
import '../customers/models';
import './models/offers';
import '../../offer/models';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "capital": {
        "nested": {
          "external": {
            "nested": {
              "business": {
                "nested": {
                  "service": {
                    "nested": {
                      "GetFinancingRequestRequest": {
                        "fields": {
                          "financingRequestToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "GetFinancingRequestResponse": {
                        "fields": {
                          "financingRequest": {
                            "type": ".squareup.capital.external.business.models.FinancingRequest",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "CancelFinancingRequestRequest": {
                        "fields": {
                          "financingRequestToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "CancelFinancingRequestResponse": {
                        "fields": {
                          "financingRequest": {
                            "type": ".squareup.capital.external.business.models.FinancingRequest",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "GetOfferSetSimulationRequest": {
                        "fields": {
                          "offerSetToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "timeZone": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "GetOfferSetSimulationResponse": {
                        "fields": {
                          "offerSetSimulations": {
                            "type": ".squareup.capital.external.business.models.OfferSimulation",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "averageMonthlyCardSalesMoney": {
                            "type": ".squareup.common.Money",
                            "id": 2,
                            "rule": "optional"
                          },
                          "paymentBreakdowns": {
                            "type": ".squareup.capital.external.business.models.PaymentBreakdown",
                            "id": 3,
                            "rule": "repeated"
                          }
                        }
                      },
                      "GetInformationRequestsRequest": {
                        "fields": {
                          "financingRequestToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "GetInformationRequestsResponse": {
                        "fields": {
                          "informationRequests": {
                            "type": ".squareup.capital.external.business.models.InformationRequest",
                            "id": 1,
                            "rule": "repeated"
                          }
                        }
                      },
                      "ListAuthorizedAfcStatusesRequest": {
                        "fields": {}
                      },
                      "ListAuthorizedAfcStatusesResponse": {
                        "fields": {
                          "statuses": {
                            "type": ".squareup.capital.external.business.models.AfcStatus",
                            "id": 2,
                            "rule": "repeated"
                          }
                        }
                      },
                      "QueryAfcStatusesRequest": {
                        "fields": {
                          "customerTokens": {
                            "type": "string",
                            "id": 1,
                            "rule": "repeated"
                          }
                        }
                      },
                      "QueryAfcStatusesResponse": {
                        "fields": {
                          "statuses": {
                            "type": ".squareup.capital.external.business.models.AfcStatus",
                            "id": 2,
                            "rule": "repeated"
                          }
                        }
                      },
                      "ListAuthorizedCustomersRequest": {
                        "fields": {}
                      },
                      "ListAuthorizedCustomersResponse": {
                        "fields": {
                          "customers": {
                            "type": ".squareup.capital.external.customers.models.Customer",
                            "id": 1,
                            "rule": "repeated"
                          }
                        }
                      },
                      "SearchCustomersRequest": {
                        "fields": {
                          "partnerIds": {
                            "type": "string",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "disableCache": {
                            "type": "bool",
                            "id": 2,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          }
                        }
                      },
                      "SearchCustomersResponse": {
                        "fields": {
                          "customers": {
                            "type": ".squareup.capital.external.business.models.Customer",
                            "id": 1,
                            "rule": "repeated"
                          }
                        }
                      },
                      "RetrieveCustomerRequest": {
                        "fields": {
                          "id": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "RetrieveCustomerResponse": {
                        "fields": {
                          "customer": {
                            "type": ".squareup.capital.external.business.models.Customer",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "BulkRetrieveCustomersRequest": {
                        "fields": {
                          "ids": {
                            "type": "string",
                            "id": 1,
                            "rule": "repeated"
                          }
                        }
                      },
                      "BulkRetrieveCustomersResponse": {
                        "fields": {
                          "responses": {
                            "type": ".squareup.capital.external.business.service.RetrieveCustomerResponse",
                            "id": 1,
                            "keyType": "string"
                          }
                        }
                      },
                      "RetrieveCustomerEligibilityRequest": {
                        "fields": {
                          "customerId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "RetrieveCustomerEligibilityResponse": {
                        "fields": {
                          "customerEligibility": {
                            "type": ".squareup.capital.external.business.models.CustomerEligibility",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "GetPOSFreezeDataRequest": {
                        "fields": {
                          "customerToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "GetPOSFreezeDataResponse": {
                        "fields": {
                          "isFrozen": {
                            "type": "bool",
                            "id": 1,
                            "rule": "optional"
                          },
                          "hasSsp": {
                            "type": "bool",
                            "id": 2,
                            "rule": "optional"
                          },
                          "sspStatus": {
                            "type": ".squareup.capital.external.business.service.GetPOSFreezeDataResponse.SSPStatus",
                            "id": 3,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "SSPStatus": {
                            "values": {
                              "SS_DO_NOT_USE": 0,
                              "AWAITING_COMPLETION": 1,
                              "AWAITING_REVIEW": 2
                            }
                          }
                        }
                      },
                      "GetCustomerMaxOfferAmountsRequest": {
                        "fields": {}
                      },
                      "GetCustomerMaxOfferAmountsResponse": {
                        "fields": {
                          "customerMaxOfferAmounts": {
                            "type": ".squareup.capital.external.business.models.CustomerMaxOfferAmount",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "totalOfferAmount": {
                            "type": ".squareup.common.Money",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "ListOffersRequest": {
                        "fields": {
                          "customerToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "expiredOfferSetTokens": {
                            "type": "string",
                            "id": 2,
                            "rule": "repeated"
                          }
                        }
                      },
                      "ListOffersResponse": {
                        "fields": {
                          "activeOfferSets": {
                            "type": ".squareup.capital.external.business.models.offers.OfferSet",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "expiredOfferSets": {
                            "type": ".squareup.capital.external.business.models.offers.OfferSet",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "products": {
                            "type": ".squareup.capital.external.business.models.offers.Product",
                            "id": 3,
                            "rule": "repeated"
                          }
                        }
                      },
                      "GetOfferSetRequest": {
                        "fields": {
                          "offerSetToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "unitToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "OfferSetMarketingSegments": {
                        "fields": {
                          "blendedLoanMarketingSegment": {
                            "type": ".squareup.capital.external.business.service.OfferSetMarketingSegments.BlendedLoanMarketingSegment",
                            "id": 1,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "BlendedLoanMarketingSegment": {
                            "values": {
                              "BLMS_DO_NOT_USE": 0,
                              "NEW_TO_SQUARE": 1,
                              "REPEAT_BORROWER": 2,
                              "PREVIOUSLY_FLEX_ELIGIBLE": 3
                            }
                          }
                        }
                      },
                      "GetOfferSetResponse": {
                        "fields": {
                          "offerSet": {
                            "type": ".squareup.capital.external.business.models.offers.OfferSet",
                            "id": 1,
                            "rule": "optional"
                          },
                          "products": {
                            "type": ".squareup.capital.external.business.models.offers.Product",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "waitPendingExtraPayment": {
                            "type": "bool",
                            "id": 3,
                            "rule": "optional"
                          },
                          "bankAccountData": {
                            "type": ".squareup.capital.external.business.models.BankAccountData",
                            "id": 4,
                            "rule": "optional"
                          },
                          "context": {
                            "type": "string",
                            "id": 5,
                            "keyType": "string"
                          },
                          "offerSetMarketingSegments": {
                            "type": ".squareup.capital.external.business.service.OfferSetMarketingSegments",
                            "id": 6,
                            "rule": "optional"
                          }
                        }
                      },
                      "UpdateFicoPullStatusRequest": {
                        "fields": {
                          "offerSetToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "ficoPullStatus": {
                            "type": ".squareup.capital.offer.models.BizConfiguration.FicoPullStatus",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "UpdateFicoPullStatusResponse": {
                        "fields": {}
                      },
                      "GetOrCreatePendingBizLoanOfferFlowRequest": {
                        "fields": {}
                      },
                      "GetOrCreatePendingBizLoanOfferFlowResponse": {
                        "fields": {
                          "offerFlowToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "wasAccountCreatedBefore2020": {
                            "type": "bool",
                            "id": 2,
                            "rule": "optional"
                          },
                          "pppOfferFlow": {
                            "type": ".squareup.capital.external.business.models.PPPOfferFlow",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "CreateOrUpdatePPPOfferSetRequest": {
                        "fields": {
                          "averageMonthlyPayrollAmountCents": {
                            "type": "uint64",
                            "id": 1,
                            "rule": "optional"
                          },
                          "offerFlowToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "outstandingEidlAmountCents": {
                            "type": "uint64",
                            "id": 3,
                            "rule": "optional"
                          },
                          "numberOfEmployees": {
                            "type": "uint32",
                            "id": 4,
                            "rule": "optional"
                          },
                          "hasEmployeesPaidOver100k": {
                            "type": "bool",
                            "id": 5,
                            "rule": "optional"
                          },
                          "isSeasonalBusiness": {
                            "type": "bool",
                            "id": 6,
                            "rule": "optional"
                          },
                          "onlyProcessedOnSquare2019": {
                            "type": "bool",
                            "id": 7,
                            "rule": "optional"
                          },
                          "businessStartedIn2020": {
                            "type": "bool",
                            "id": 8,
                            "rule": "optional"
                          },
                          "pppOfferFlow": {
                            "type": ".squareup.capital.external.business.models.PPPOfferFlow",
                            "id": 9,
                            "rule": "optional"
                          },
                          "plaidLinkageVendorSnapshotToken": {
                            "type": "string",
                            "id": 10,
                            "rule": "optional"
                          }
                        }
                      },
                      "CreateOrUpdatePPPOfferSetResponse": {
                        "fields": {}
                      },
                      "ExpirePPPOfferSetRequest": {
                        "fields": {
                          "offerSetToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "ExpirePPPOfferSetResponse": {
                        "fields": {}
                      },
                      "DuplicatePPPOfferFlowRequest": {
                        "fields": {
                          "offerSetToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "offerFlowToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "DuplicatePPPOfferFlowResponse": {
                        "fields": {
                          "pppOfferFlow": {
                            "type": ".squareup.capital.external.business.models.PPPOfferFlow",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "UpdatePPPOfferFlowRequest": {
                        "fields": {
                          "pppOfferFlow": {
                            "type": ".squareup.capital.external.business.models.PPPOfferFlow",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "UpdatePPPOfferFlowResponse": {
                        "fields": {
                          "pppOfferFlow": {
                            "type": ".squareup.capital.external.business.models.PPPOfferFlow",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "AcceptCounterOfferRequest": {
                        "fields": {
                          "financingRequestToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "AcceptCounterOfferResponse": {
                        "fields": {
                          "financingRequest": {
                            "type": ".squareup.capital.external.business.models.FinancingRequest",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "FinancingRequestService": {
                        "methods": {
                          "ListOffers": {
                            "requestType": ".squareup.capital.external.business.service.ListOffersRequest",
                            "responseType": ".squareup.capital.external.business.service.ListOffersResponse"
                          },
                          "GetOfferSet": {
                            "requestType": ".squareup.capital.external.business.service.GetOfferSetRequest",
                            "responseType": ".squareup.capital.external.business.service.GetOfferSetResponse"
                          },
                          "UpdateFicoPullStatus": {
                            "requestType": ".squareup.capital.external.business.service.UpdateFicoPullStatusRequest",
                            "responseType": ".squareup.capital.external.business.service.UpdateFicoPullStatusResponse"
                          },
                          "CreateOrUpdatePPPOfferSet": {
                            "requestType": ".squareup.capital.external.business.service.CreateOrUpdatePPPOfferSetRequest",
                            "responseType": ".squareup.capital.external.business.service.CreateOrUpdatePPPOfferSetResponse"
                          },
                          "ExpirePPPOfferSet": {
                            "requestType": ".squareup.capital.external.business.service.ExpirePPPOfferSetRequest",
                            "responseType": ".squareup.capital.external.business.service.ExpirePPPOfferSetResponse"
                          },
                          "DuplicatePPPOfferFlow": {
                            "requestType": ".squareup.capital.external.business.service.DuplicatePPPOfferFlowRequest",
                            "responseType": ".squareup.capital.external.business.service.DuplicatePPPOfferFlowResponse"
                          },
                          "UpdatePPPOfferFlow": {
                            "requestType": ".squareup.capital.external.business.service.UpdatePPPOfferFlowRequest",
                            "responseType": ".squareup.capital.external.business.service.UpdatePPPOfferFlowResponse"
                          },
                          "GetOrCreatePendingBizLoanOfferFlow": {
                            "requestType": ".squareup.capital.external.business.service.GetOrCreatePendingBizLoanOfferFlowRequest",
                            "responseType": ".squareup.capital.external.business.service.GetOrCreatePendingBizLoanOfferFlowResponse"
                          },
                          "GetFinancingRequest": {
                            "requestType": ".squareup.capital.external.business.service.GetFinancingRequestRequest",
                            "responseType": ".squareup.capital.external.business.service.GetFinancingRequestResponse"
                          },
                          "CancelFinancingRequest": {
                            "requestType": ".squareup.capital.external.business.service.CancelFinancingRequestRequest",
                            "responseType": ".squareup.capital.external.business.service.CancelFinancingRequestResponse"
                          },
                          "GetOfferSetSimulation": {
                            "requestType": ".squareup.capital.external.business.service.GetOfferSetSimulationRequest",
                            "responseType": ".squareup.capital.external.business.service.GetOfferSetSimulationResponse"
                          },
                          "GetInformationRequests": {
                            "requestType": ".squareup.capital.external.business.service.GetInformationRequestsRequest",
                            "responseType": ".squareup.capital.external.business.service.GetInformationRequestsResponse"
                          },
                          "AcceptCounterOffer": {
                            "requestType": ".squareup.capital.external.business.service.AcceptCounterOfferRequest",
                            "responseType": ".squareup.capital.external.business.service.AcceptCounterOfferResponse"
                          },
                          "ListAuthorizedAfcStatuses": {
                            "requestType": ".squareup.capital.external.business.service.ListAuthorizedAfcStatusesRequest",
                            "responseType": ".squareup.capital.external.business.service.ListAuthorizedAfcStatusesResponse"
                          },
                          "QueryAfcStatuses": {
                            "requestType": ".squareup.capital.external.business.service.QueryAfcStatusesRequest",
                            "responseType": ".squareup.capital.external.business.service.QueryAfcStatusesResponse"
                          },
                          "GetCustomerMaxOfferAmounts": {
                            "requestType": ".squareup.capital.external.business.service.GetCustomerMaxOfferAmountsRequest",
                            "responseType": ".squareup.capital.external.business.service.GetCustomerMaxOfferAmountsResponse"
                          }
                        }
                      },
                      "CustomerService": {
                        "methods": {
                          "SearchCustomers": {
                            "requestType": ".squareup.capital.external.business.service.SearchCustomersRequest",
                            "responseType": ".squareup.capital.external.business.service.SearchCustomersResponse"
                          },
                          "RetrieveCustomer": {
                            "requestType": ".squareup.capital.external.business.service.RetrieveCustomerRequest",
                            "responseType": ".squareup.capital.external.business.service.RetrieveCustomerResponse"
                          },
                          "BulkRetrieveCustomers": {
                            "requestType": ".squareup.capital.external.business.service.BulkRetrieveCustomersRequest",
                            "responseType": ".squareup.capital.external.business.service.BulkRetrieveCustomersResponse"
                          },
                          "RetrieveCustomerEligibility": {
                            "requestType": ".squareup.capital.external.business.service.RetrieveCustomerEligibilityRequest",
                            "responseType": ".squareup.capital.external.business.service.RetrieveCustomerEligibilityResponse"
                          },
                          "ListAuthorizedCustomers": {
                            "requestType": ".squareup.capital.external.business.service.ListAuthorizedCustomersRequest",
                            "responseType": ".squareup.capital.external.business.service.ListAuthorizedCustomersResponse"
                          },
                          "GetPOSFreezeData": {
                            "requestType": ".squareup.capital.external.business.service.GetPOSFreezeDataRequest",
                            "responseType": ".squareup.capital.external.business.service.GetPOSFreezeDataResponse"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.GetFinancingRequestRequest && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.GetFinancingRequestResponse && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.CancelFinancingRequestRequest && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.CancelFinancingRequestResponse && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.GetOfferSetSimulationRequest && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.GetOfferSetSimulationResponse && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.GetInformationRequestsRequest && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.GetInformationRequestsResponse && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.ListAuthorizedAfcStatusesRequest && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.ListAuthorizedAfcStatusesResponse && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.QueryAfcStatusesRequest && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.QueryAfcStatusesResponse && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.ListAuthorizedCustomersRequest && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.ListAuthorizedCustomersResponse && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.SearchCustomersRequest && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.SearchCustomersResponse && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.RetrieveCustomerRequest && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.RetrieveCustomerResponse && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.BulkRetrieveCustomersRequest && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.BulkRetrieveCustomersResponse && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.RetrieveCustomerEligibilityRequest && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.RetrieveCustomerEligibilityResponse && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.GetPOSFreezeDataRequest && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.GetPOSFreezeDataResponse && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.GetPOSFreezeDataResponse?.nested?.SSPStatus && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.GetCustomerMaxOfferAmountsRequest && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.GetCustomerMaxOfferAmountsResponse && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.ListOffersRequest && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.ListOffersResponse && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.GetOfferSetRequest && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.OfferSetMarketingSegments && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.OfferSetMarketingSegments?.nested?.BlendedLoanMarketingSegment && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.GetOfferSetResponse && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.UpdateFicoPullStatusRequest && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.UpdateFicoPullStatusResponse && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.GetOrCreatePendingBizLoanOfferFlowRequest && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.GetOrCreatePendingBizLoanOfferFlowResponse && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.CreateOrUpdatePPPOfferSetRequest && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.CreateOrUpdatePPPOfferSetResponse && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.ExpirePPPOfferSetRequest && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.ExpirePPPOfferSetResponse && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.DuplicatePPPOfferFlowRequest && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.DuplicatePPPOfferFlowResponse && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.UpdatePPPOfferFlowRequest && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.UpdatePPPOfferFlowResponse && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.AcceptCounterOfferRequest && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.AcceptCounterOfferResponse && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.FinancingRequestService && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.service?.nested?.CustomerService) {
  $root.addJSON(jsonData);
}

/**
 * Messages
 * ========================================
 *
 * SOURCE GetFinancingRequestRequest @ squareup/capital/external/business/service.proto at 198:1
 */
export const GetFinancingRequestRequest = $root.lookupType('squareup.capital.external.business.service.GetFinancingRequestRequest');
fixType(GetFinancingRequestRequest, {
  financingRequestToken: {
    required: true
  }
});
Builder.createAndAttachToType(GetFinancingRequestRequest);
/**
 * SOURCE GetFinancingRequestResponse @ squareup/capital/external/business/service.proto at 202:1
 */
export const GetFinancingRequestResponse = $root.lookupType('squareup.capital.external.business.service.GetFinancingRequestResponse');
fixType(GetFinancingRequestResponse, {
  financingRequest: {
    required: true
  }
});
Builder.createAndAttachToType(GetFinancingRequestResponse);
/**
 * SOURCE CancelFinancingRequestRequest @ squareup/capital/external/business/service.proto at 206:1
 */
export const CancelFinancingRequestRequest = $root.lookupType('squareup.capital.external.business.service.CancelFinancingRequestRequest');
fixType(CancelFinancingRequestRequest);
Builder.createAndAttachToType(CancelFinancingRequestRequest);
/**
 * SOURCE CancelFinancingRequestResponse @ squareup/capital/external/business/service.proto at 210:1
 */
export const CancelFinancingRequestResponse = $root.lookupType('squareup.capital.external.business.service.CancelFinancingRequestResponse');
fixType(CancelFinancingRequestResponse, {
  financingRequest: {
    required: true
  }
});
Builder.createAndAttachToType(CancelFinancingRequestResponse);
/**
 * SOURCE GetOfferSetSimulationRequest @ squareup/capital/external/business/service.proto at 214:1
 */
export const GetOfferSetSimulationRequest = $root.lookupType('squareup.capital.external.business.service.GetOfferSetSimulationRequest');
fixType(GetOfferSetSimulationRequest, {
  offerSetToken: {
    required: true
  }
});
Builder.createAndAttachToType(GetOfferSetSimulationRequest);
/**
 * SOURCE GetOfferSetSimulationResponse @ squareup/capital/external/business/service.proto at 227:1
 */
export const GetOfferSetSimulationResponse = $root.lookupType('squareup.capital.external.business.service.GetOfferSetSimulationResponse');
fixType(GetOfferSetSimulationResponse);
Builder.createAndAttachToType(GetOfferSetSimulationResponse);
/**
 * SOURCE GetInformationRequestsRequest @ squareup/capital/external/business/service.proto at 237:1
 */
export const GetInformationRequestsRequest = $root.lookupType('squareup.capital.external.business.service.GetInformationRequestsRequest');
fixType(GetInformationRequestsRequest, {
  financingRequestToken: {
    required: true
  }
});
Builder.createAndAttachToType(GetInformationRequestsRequest);
/**
 * SOURCE GetInformationRequestsResponse @ squareup/capital/external/business/service.proto at 241:1
 */
export const GetInformationRequestsResponse = $root.lookupType('squareup.capital.external.business.service.GetInformationRequestsResponse');
fixType(GetInformationRequestsResponse);
Builder.createAndAttachToType(GetInformationRequestsResponse);
/**
 * Intentionally empty, response will be based on the currently authorized
 * multipass person.
 *
 * SOURCE ListAuthorizedAfcStatusesRequest @ squareup/capital/external/business/service.proto at 331:1
 */
export const ListAuthorizedAfcStatusesRequest = $root.lookupType('squareup.capital.external.business.service.ListAuthorizedAfcStatusesRequest');
fixType(ListAuthorizedAfcStatusesRequest);
Builder.createAndAttachToType(ListAuthorizedAfcStatusesRequest);
/**
 * SOURCE ListAuthorizedAfcStatusesResponse @ squareup/capital/external/business/service.proto at 334:1
 */
export const ListAuthorizedAfcStatusesResponse = $root.lookupType('squareup.capital.external.business.service.ListAuthorizedAfcStatusesResponse');
fixType(ListAuthorizedAfcStatusesResponse, {
  statuses: {
    required: true
  }
});
Builder.createAndAttachToType(ListAuthorizedAfcStatusesResponse);
/**
 * SOURCE QueryAfcStatusesRequest @ squareup/capital/external/business/service.proto at 338:1
 */
export const QueryAfcStatusesRequest = $root.lookupType('squareup.capital.external.business.service.QueryAfcStatusesRequest');
fixType(QueryAfcStatusesRequest, {
  customerTokens: {
    required: true
  }
});
Builder.createAndAttachToType(QueryAfcStatusesRequest);
/**
 * SOURCE QueryAfcStatusesResponse @ squareup/capital/external/business/service.proto at 343:1
 */
export const QueryAfcStatusesResponse = $root.lookupType('squareup.capital.external.business.service.QueryAfcStatusesResponse');
fixType(QueryAfcStatusesResponse, {
  statuses: {
    required: true
  }
});
Builder.createAndAttachToType(QueryAfcStatusesResponse);
/**
 * Intentionally empty, response will be based on the currently authorized
 * multipass person.
 *
 * SOURCE ListAuthorizedCustomersRequest @ squareup/capital/external/business/service.proto at 349:1
 */
export const ListAuthorizedCustomersRequest = $root.lookupType('squareup.capital.external.business.service.ListAuthorizedCustomersRequest');
fixType(ListAuthorizedCustomersRequest);
Builder.createAndAttachToType(ListAuthorizedCustomersRequest);
/**
 * SOURCE ListAuthorizedCustomersResponse @ squareup/capital/external/business/service.proto at 352:1
 */
export const ListAuthorizedCustomersResponse = $root.lookupType('squareup.capital.external.business.service.ListAuthorizedCustomersResponse');
fixType(ListAuthorizedCustomersResponse);
Builder.createAndAttachToType(ListAuthorizedCustomersResponse);
/**
 * SOURCE SearchCustomersRequest @ squareup/capital/external/business/service.proto at 356:1
 */
export const SearchCustomersRequest = $root.lookupType('squareup.capital.external.business.service.SearchCustomersRequest');
fixType(SearchCustomersRequest);
Builder.createAndAttachToType(SearchCustomersRequest);
/**
 * SOURCE SearchCustomersResponse @ squareup/capital/external/business/service.proto at 364:1
 */
export const SearchCustomersResponse = $root.lookupType('squareup.capital.external.business.service.SearchCustomersResponse');
fixType(SearchCustomersResponse);
Builder.createAndAttachToType(SearchCustomersResponse);
/**
 * SOURCE RetrieveCustomerRequest @ squareup/capital/external/business/service.proto at 368:1
 */
export const RetrieveCustomerRequest = $root.lookupType('squareup.capital.external.business.service.RetrieveCustomerRequest');
fixType(RetrieveCustomerRequest, {
  id: {
    required: true
  }
});
Builder.createAndAttachToType(RetrieveCustomerRequest);
/**
 * SOURCE RetrieveCustomerResponse @ squareup/capital/external/business/service.proto at 373:1
 */
export const RetrieveCustomerResponse = $root.lookupType('squareup.capital.external.business.service.RetrieveCustomerResponse');
fixType(RetrieveCustomerResponse);
Builder.createAndAttachToType(RetrieveCustomerResponse);
/**
 * SOURCE BulkRetrieveCustomersRequest @ squareup/capital/external/business/service.proto at 377:1
 */
export const BulkRetrieveCustomersRequest = $root.lookupType('squareup.capital.external.business.service.BulkRetrieveCustomersRequest');
fixType(BulkRetrieveCustomersRequest, {
  ids: {
    required: true
  }
});
Builder.createAndAttachToType(BulkRetrieveCustomersRequest);
/**
 * SOURCE BulkRetrieveCustomersResponse @ squareup/capital/external/business/service.proto at 382:1
 */
export const BulkRetrieveCustomersResponse = $root.lookupType('squareup.capital.external.business.service.BulkRetrieveCustomersResponse');
fixType(BulkRetrieveCustomersResponse);
Builder.createAndAttachToType(BulkRetrieveCustomersResponse);
/**
 * SOURCE RetrieveCustomerEligibilityRequest @ squareup/capital/external/business/service.proto at 386:1
 */
export const RetrieveCustomerEligibilityRequest = $root.lookupType('squareup.capital.external.business.service.RetrieveCustomerEligibilityRequest');
fixType(RetrieveCustomerEligibilityRequest, {
  customerId: {
    required: true
  }
});
Builder.createAndAttachToType(RetrieveCustomerEligibilityRequest);
/**
 * SOURCE RetrieveCustomerEligibilityResponse @ squareup/capital/external/business/service.proto at 390:1
 */
export const RetrieveCustomerEligibilityResponse = $root.lookupType('squareup.capital.external.business.service.RetrieveCustomerEligibilityResponse');
fixType(RetrieveCustomerEligibilityResponse, {
  customerEligibility: {
    required: true
  }
});
Builder.createAndAttachToType(RetrieveCustomerEligibilityResponse);
/**
 * SOURCE GetPOSFreezeDataRequest @ squareup/capital/external/business/service.proto at 394:1
 */
export const GetPOSFreezeDataRequest = $root.lookupType('squareup.capital.external.business.service.GetPOSFreezeDataRequest');
fixType(GetPOSFreezeDataRequest, {
  customerToken: {
    required: true
  }
});
Builder.createAndAttachToType(GetPOSFreezeDataRequest);
/**
 * SOURCE GetPOSFreezeDataResponse @ squareup/capital/external/business/service.proto at 399:1
 */
export const GetPOSFreezeDataResponse = $root.lookupType('squareup.capital.external.business.service.GetPOSFreezeDataResponse');
fixType(GetPOSFreezeDataResponse, {
  isFrozen: {
    required: true
  }
});
Builder.createAndAttachToType(GetPOSFreezeDataResponse);
/**
 * SOURCE SSPStatus @ squareup/capital/external/business/service.proto at 406:3
 */
GetPOSFreezeDataResponse.SSPStatus = $root.lookupEnum('squareup.capital.external.business.service.GetPOSFreezeDataResponse.SSPStatus').values;
/**
 * Intentionally empty, response will be based on the currently authorized
 * multipass person.
 *
 * SOURCE GetCustomerMaxOfferAmountsRequest @ squareup/capital/external/business/service.proto at 418:1
 */
export const GetCustomerMaxOfferAmountsRequest = $root.lookupType('squareup.capital.external.business.service.GetCustomerMaxOfferAmountsRequest');
fixType(GetCustomerMaxOfferAmountsRequest);
Builder.createAndAttachToType(GetCustomerMaxOfferAmountsRequest);
/**
 * SOURCE GetCustomerMaxOfferAmountsResponse @ squareup/capital/external/business/service.proto at 421:1
 */
export const GetCustomerMaxOfferAmountsResponse = $root.lookupType('squareup.capital.external.business.service.GetCustomerMaxOfferAmountsResponse');
fixType(GetCustomerMaxOfferAmountsResponse, {
  totalOfferAmount: {
    required: true
  }
});
Builder.createAndAttachToType(GetCustomerMaxOfferAmountsResponse);
/**
 * SOURCE ListOffersRequest @ squareup/capital/external/business/service.proto at 428:1
 */
export const ListOffersRequest = $root.lookupType('squareup.capital.external.business.service.ListOffersRequest');
fixType(ListOffersRequest, {
  customerToken: {
    required: true
  }
});
Builder.createAndAttachToType(ListOffersRequest);
/**
 * SOURCE ListOffersResponse @ squareup/capital/external/business/service.proto at 441:1
 */
export const ListOffersResponse = $root.lookupType('squareup.capital.external.business.service.ListOffersResponse');
fixType(ListOffersResponse);
Builder.createAndAttachToType(ListOffersResponse);
/**
 * SOURCE GetOfferSetRequest @ squareup/capital/external/business/service.proto at 455:1
 */
export const GetOfferSetRequest = $root.lookupType('squareup.capital.external.business.service.GetOfferSetRequest');
fixType(GetOfferSetRequest, {
  offerSetToken: {
    required: true
  }
});
Builder.createAndAttachToType(GetOfferSetRequest);
/**
 * SOURCE OfferSetMarketingSegments @ squareup/capital/external/business/service.proto at 460:1
 */
export const OfferSetMarketingSegments = $root.lookupType('squareup.capital.external.business.service.OfferSetMarketingSegments');
fixType(OfferSetMarketingSegments);
Builder.createAndAttachToType(OfferSetMarketingSegments);
/**
 * SOURCE BlendedLoanMarketingSegment @ squareup/capital/external/business/service.proto at 461:3
 */
OfferSetMarketingSegments.BlendedLoanMarketingSegment = $root.lookupEnum('squareup.capital.external.business.service.OfferSetMarketingSegments.BlendedLoanMarketingSegment').values;
/**
 * SOURCE GetOfferSetResponse @ squareup/capital/external/business/service.proto at 471:1
 */
export const GetOfferSetResponse = $root.lookupType('squareup.capital.external.business.service.GetOfferSetResponse');
fixType(GetOfferSetResponse, {
  offerSet: {
    required: true
  }
});
Builder.createAndAttachToType(GetOfferSetResponse);
/**
 * SOURCE UpdateFicoPullStatusRequest @ squareup/capital/external/business/service.proto at 491:1
 */
export const UpdateFicoPullStatusRequest = $root.lookupType('squareup.capital.external.business.service.UpdateFicoPullStatusRequest');
fixType(UpdateFicoPullStatusRequest, {
  offerSetToken: {
    required: true
  },
  ficoPullStatus: {
    required: true
  }
});
Builder.createAndAttachToType(UpdateFicoPullStatusRequest);
/**
 * SOURCE UpdateFicoPullStatusResponse @ squareup/capital/external/business/service.proto at 498:1
 */
export const UpdateFicoPullStatusResponse = $root.lookupType('squareup.capital.external.business.service.UpdateFicoPullStatusResponse');
fixType(UpdateFicoPullStatusResponse);
Builder.createAndAttachToType(UpdateFicoPullStatusResponse);
/**
 * SOURCE GetOrCreatePendingBizLoanOfferFlowRequest @ squareup/capital/external/business/service.proto at 501:1
 */
export const GetOrCreatePendingBizLoanOfferFlowRequest = $root.lookupType('squareup.capital.external.business.service.GetOrCreatePendingBizLoanOfferFlowRequest');
fixType(GetOrCreatePendingBizLoanOfferFlowRequest);
Builder.createAndAttachToType(GetOrCreatePendingBizLoanOfferFlowRequest);
/**
 * SOURCE GetOrCreatePendingBizLoanOfferFlowResponse @ squareup/capital/external/business/service.proto at 504:1
 */
export const GetOrCreatePendingBizLoanOfferFlowResponse = $root.lookupType('squareup.capital.external.business.service.GetOrCreatePendingBizLoanOfferFlowResponse');
fixType(GetOrCreatePendingBizLoanOfferFlowResponse);
Builder.createAndAttachToType(GetOrCreatePendingBizLoanOfferFlowResponse);
/**
 * SOURCE CreateOrUpdatePPPOfferSetRequest @ squareup/capital/external/business/service.proto at 515:1
 */
export const CreateOrUpdatePPPOfferSetRequest = $root.lookupType('squareup.capital.external.business.service.CreateOrUpdatePPPOfferSetRequest');
fixType(CreateOrUpdatePPPOfferSetRequest);
Builder.createAndAttachToType(CreateOrUpdatePPPOfferSetRequest);
/**
 * SOURCE CreateOrUpdatePPPOfferSetResponse @ squareup/capital/external/business/service.proto at 547:1
 */
export const CreateOrUpdatePPPOfferSetResponse = $root.lookupType('squareup.capital.external.business.service.CreateOrUpdatePPPOfferSetResponse');
fixType(CreateOrUpdatePPPOfferSetResponse);
Builder.createAndAttachToType(CreateOrUpdatePPPOfferSetResponse);
/**
 * SOURCE ExpirePPPOfferSetRequest @ squareup/capital/external/business/service.proto at 549:1
 */
export const ExpirePPPOfferSetRequest = $root.lookupType('squareup.capital.external.business.service.ExpirePPPOfferSetRequest');
fixType(ExpirePPPOfferSetRequest);
Builder.createAndAttachToType(ExpirePPPOfferSetRequest);
/**
 * SOURCE ExpirePPPOfferSetResponse @ squareup/capital/external/business/service.proto at 554:1
 */
export const ExpirePPPOfferSetResponse = $root.lookupType('squareup.capital.external.business.service.ExpirePPPOfferSetResponse');
fixType(ExpirePPPOfferSetResponse);
Builder.createAndAttachToType(ExpirePPPOfferSetResponse);
/**
 * SOURCE DuplicatePPPOfferFlowRequest @ squareup/capital/external/business/service.proto at 556:1
 */
export const DuplicatePPPOfferFlowRequest = $root.lookupType('squareup.capital.external.business.service.DuplicatePPPOfferFlowRequest');
fixType(DuplicatePPPOfferFlowRequest);
Builder.createAndAttachToType(DuplicatePPPOfferFlowRequest);
/**
 * SOURCE DuplicatePPPOfferFlowResponse @ squareup/capital/external/business/service.proto at 564:1
 */
export const DuplicatePPPOfferFlowResponse = $root.lookupType('squareup.capital.external.business.service.DuplicatePPPOfferFlowResponse');
fixType(DuplicatePPPOfferFlowResponse);
Builder.createAndAttachToType(DuplicatePPPOfferFlowResponse);
/**
 * SOURCE UpdatePPPOfferFlowRequest @ squareup/capital/external/business/service.proto at 569:1
 */
export const UpdatePPPOfferFlowRequest = $root.lookupType('squareup.capital.external.business.service.UpdatePPPOfferFlowRequest');
fixType(UpdatePPPOfferFlowRequest);
Builder.createAndAttachToType(UpdatePPPOfferFlowRequest);
/**
 * SOURCE UpdatePPPOfferFlowResponse @ squareup/capital/external/business/service.proto at 575:1
 */
export const UpdatePPPOfferFlowResponse = $root.lookupType('squareup.capital.external.business.service.UpdatePPPOfferFlowResponse');
fixType(UpdatePPPOfferFlowResponse);
Builder.createAndAttachToType(UpdatePPPOfferFlowResponse);
/**
 * SOURCE AcceptCounterOfferRequest @ squareup/capital/external/business/service.proto at 589:1
 */
export const AcceptCounterOfferRequest = $root.lookupType('squareup.capital.external.business.service.AcceptCounterOfferRequest');
fixType(AcceptCounterOfferRequest, {
  financingRequestToken: {
    required: true
  }
});
Builder.createAndAttachToType(AcceptCounterOfferRequest);
/**
 * SOURCE AcceptCounterOfferResponse @ squareup/capital/external/business/service.proto at 594:1
 */
export const AcceptCounterOfferResponse = $root.lookupType('squareup.capital.external.business.service.AcceptCounterOfferResponse');
fixType(AcceptCounterOfferResponse);
Builder.createAndAttachToType(AcceptCounterOfferResponse);
/**
 * Support for financing request related RPCs. These are intended to support
 * Square Business Loans, and all requests will be multipass authenticated.
 *
 * SOURCE FinancingRequestService @ squareup/capital/external/business/service.proto at 69:1
 */
export const FinancingRequestService = $root.lookupService('squareup.capital.external.business.service.FinancingRequestService');
/**
 * NOTE: This service follows the Square API specification. Any modifications
 * should match the specification.
 *
 * https://plathome.sqprod.co/docs/design/introduction
 *
 * SOURCE CustomerService @ squareup/capital/external/business/service.proto at 159:1
 */
export const CustomerService = $root.lookupService('squareup.capital.external.business.service.CustomerService');